/**
 * RelevantConsent is injected by GTM, outside React, and exposes no locale API.
 * Adapt only its display text: never replace elements, handlers, data-cat
 * identifiers, checkbox state, storage, or consent records.
 */
export const CONSENT_ES: Record<string, string> = {
  "Privacy & Tracking Preferences": "Preferencias de privacidad y seguimiento",
  "We use cookies and similar technologies to analyze activity, support advertising, personalize content, and may use tools that associate visits with individuals or households.": "Utilizamos cookies y tecnologías similares para analizar la actividad, facilitar la publicidad y personalizar el contenido. También podemos utilizar herramientas que asocian las visitas con personas u hogares.",
  "Accept all": "Aceptar todo",
  "Reject all": "Rechazar todo",
  "Customize": "Personalizar",
  "Save preferences": "Guardar preferencias",
  "Strictly necessary": "Estrictamente necesarias",
  "Analytics": "Análisis",
  "Advertising": "Publicidad",
  "Personalization": "Personalización",
  "Identity resolution": "Identificación de visitantes",
  "Privacy Policy": "Política de privacidad",
  "Terms & Conditions": "Términos y condiciones",
  "Cookie Policy": "Política de cookies",
  "Do Not Sell": "No vender mis datos",
  "Powered by Relevant Domain": "Desarrollado por Relevant Domain",
  "Privacy preferences": "Preferencias de privacidad",
  "Close": "Cerrar",
  "Close Privacy Policy": "Cerrar la política de privacidad",
  "Close Terms & Conditions": "Cerrar los términos y condiciones",
};

const REVERSE = Object.fromEntries(Object.entries(CONSENT_ES).map(([en, es]) => [es, en]));
export function consentText(text: string, spanish: boolean): string {
  const key = text.trim();
  const english = REVERSE[key] ?? key;
  const translated = spanish ? CONSENT_ES[english] : english;
  return translated ? text.replace(key, translated) : text;
}

export function observeConsentLanguage(spanish: boolean): () => void {
  const translate = () => {
    // The provider appends its banners/modals as direct body children.
    const roots = [...document.body.children].filter((el) =>
      el.id === "rd-consent-floating" ||
      (el.id !== "root" && !!el.querySelector('[data-rd="accept"], [data-cat="necessary"], [data-policy-close]')),
    );
    for (const root of roots) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node: Node | null;
      while ((node = walker.nextNode())) {
        const value = consentText(node.nodeValue ?? "", spanish);
        if (value !== node.nodeValue) node.nodeValue = value;
      }
      for (const el of [root, ...root.querySelectorAll("[aria-label]")]) {
        const label = el.getAttribute("aria-label");
        if (label) {
          const value = consentText(label, spanish);
          if (value !== label) el.setAttribute("aria-label", value);
        }
      }
    }
  };
  const observer = new MutationObserver(translate);
  observer.observe(document.body, { childList: true, subtree: true });
  translate();
  return () => observer.disconnect();
}
